import type { Category } from "./types";

export const categories: { name: Category; emoji: string; description: string }[] = [
  { name: "Menyerang Lawan", emoji: "⚔️", description: "Fallacy yang fokus menyerang orangnya, bukan argumennya" },
  { name: "Argumen Lemah", emoji: "🧱", description: "Argumen yang dibangun di atas fondasi yang rapuh" },
  { name: "Manipulasi Emosi & Sosial", emoji: "🎭", description: "Memanfaatkan perasaan atau tekanan sosial" },
  { name: "Logika Rusak", emoji: "🔧", description: "Struktur logika yang cacat atau berputar" },
  { name: "Manipulasi Statistik", emoji: "📊", description: "Trik angka, grafik, dan data yang menyesatkan" },
  { name: "Jebakan Strategi", emoji: "♟️", description: "Kesalahan berpikir strategis dari teori permainan" },
  { name: "Otak yang Menipu Diri", emoji: "🧠", description: "Bias kognitif yang membuat kita irasional secara sistematis" },
  { name: "Jebakan Bahasa", emoji: "🗣️", description: "Permainan kata dan bahasa yang menyesatkan argumen" },
  { name: "Jebakan Digital", emoji: "📱", description: "Jebakan logika khas era media sosial dan internet" },
];
